import axios from 'axios'

export default {
  search: function (request) {
    return axios.get('/api/journalippsu/search', { params: request })
  },
  find: function (id) {
    return axios.get('/api/journalippsu/'+ id)
  },
  create: function (data) {
    return axios.post('/api/journalippsu', data)
  },
  update: function (id, data) {
    return axios.put('/api/journalippsu/' + id, data)
  },
  delete: function (id) {
    return axios.delete('/api/journalippsu/' + id)
  },
  importData: function(journalId) {
    return axios.post('/api/journalippsu/import/' + journalId, {});
  },
  importAllData: function() {
    return axios.get('/api/journalippsu/importAll', {});
  }
}